import { Stack, Typography, styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import { format, parseISO } from "date-fns";
import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { resetSubmissionButton } from "../Redux/Mailer";
// import Regeneratepopup from "../MailComponent/Regenratepopup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { fetchCampaignsData, handleCampainIDSelection } from "../Redux/Mailer";
import "./MailForm.css";
import WelcomeNameContainer from "./WelcomeNameContainer";

const CustomRadio = styled(Radio)(({ theme }) => ({
 "&.Mui-checked": {
  color: "#9c27b0", // Purple for the checked state
 },
 "& .MuiSvgIcon-root": {
  fontSize: "1.5rem", // Custom icon size
 },
 "&:hover": {
  backgroundColor: "rgba(156, 39, 176, 0.08)", // Optional hover effect
 },
}));
const WhiteBorderTextField = styled(TextField)`
 & label.Mui-focused {
  color: #a804ff;
 }
 & .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
   border-color: #a814ff;
   border-width: 1px;
  }
 }
`;

const MailForm = ({
 programList,
 programName,
 setProgramName,
 launchDate,
 setLaunchDate,

 targAudience,
 setTargAudience,
 callToAction,
 setCallToAction,
 contactInfo,
 setContactInfo,
 additionalResources,
 handleReset,
 setAdditionalResources,
 setNavigatedToForm,
 setIntroduction,
 introduction,
 open,
 setOpen,
 handleGenerate,
 isMailGenerated,
 setIsMailGenerated,
 navigatedToForm,
 categoryName,
 setCategoryName,
 setAdditionalInfo,
 additionalInfo,
 setLaunchCampaignVal,
 launchCampaignVal,
 setCampaignItem,
 campaignItem,
}) => {
 const campaignList = useSelector((state) => state.model.campaignList);
 const options =
  campaignList.message !== "No campaign for this user." && campaignList.length > 0
   ? campaignList.map((item) => ({ id: item.id, name: item.name }))
   : [];
 const today = new Date().toISOString().split("T")[0];
 const handleRadioChange = (e) => {
  setCategoryName(e.target.value);
  dispatch(fetchCampaignsData(e.target.value));

  handleRadioChangeReset();
 };
 const handleChange = (event) => {
  if (event.target.value == "no") {
   setCampaignItem(0);
   dispatch(handleCampainIDSelection(0));
  }
  handleRadioChangeReset();
  setLaunchCampaignVal(event.target.value);
 };
 const handleRadioChangeReset = () => {
  setProgramName("");
  setIntroduction(null);
  setAdditionalResources("");
  setCallToAction("");
  setContactInfo("");
  setLaunchDate("");
  setTargAudience("");

  setIsMailGenerated("");
  setAdditionalInfo("");
  setCampaignItem(0);
  setLaunchCampaignVal(null);
  dispatch(resetSubmissionButton());
  setIsMailGenerated("init");

  setNavigatedToForm(false);
 };

 const dispatch = useDispatch();
 
 const handleCampaignID = (val) => {
  if (val) {
   setCampaignItem(val.id);
   let campaignID = val.id;
   let data = campaignList.filter((val) => val.id == campaignID);
   setProgramName(data[0].name);

   const item = data[0].selectedItems.filter(
    (val) => val.title == "Learning Journey Start"
   );
   let initialDate;
   if (item.length != 0) {
    initialDate = format(parseISO(item[0].date), "yyyy-MM-dd");
   } else {
    initialDate = "";
   }

   setLaunchDate(initialDate);
   dispatch(handleCampainIDSelection(campaignID));
  }
 };
 const ITEM_HEIGHT = 48;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
  PaperProps: {
   style: {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 200,
   },
  },
 };
 const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
   backgroundColor: "#f5f5f9",
   color: "rgba(0, 0, 0, 0.87)",
   maxWidth: 220,
   fontSize: theme.typography.pxToRem(12),
   border: "1px solid #dadde9",
  },
 }));
 useEffect(() => {
  dispatch(fetchCampaignsData(categoryName));
 }, []);
 return (
  <>
   <Stack>
    <Stack sx={{ width: "100%" }}>
     <WelcomeNameContainer currentComp="Launch" />
     <Stack spacing={1} className="mail-form-container-stack">
      <div className="mail-form-container">
       <div className="mailer-form-categories-section">
        <label class="mailer-form-categories-container">
         <span className="mailer-form-categories-text">Learning Program</span>
         <input
          type="radio"
          checked={categoryName === "Program"}
          value="Program"
          name="radio-category"
          onChange={handleRadioChange}
         />
         <span class="mailer-form-categories-checkmark"></span>
        </label>
        <label class="mailer-form-categories-container">
         <span className="mailer-form-categories-text">Event</span>
         <input
          type="radio"
          checked={categoryName === "Event"}
          value="Event"
          name="radio-category"
          onChange={handleRadioChange}
         />
         <span class="mailer-form-categories-checkmark"></span>
        </label>
        <label class="mailer-form-categories-container">
         <span className="mailer-form-categories-text">Microsite/Tool/Platform</span>
         <input
          type="radio"
          checked={categoryName === "Microsite/Tool/Platform"}
          value="Microsite/Tool/Platform"
          name="radio-category"
          onChange={handleRadioChange}
         />
         <span class="mailer-form-categories-checkmark"></span>
        </label>

        <label class="mailer-form-categories-container">
         <span className="mailer-form-categories-text">Webinar</span>
         <input
          type="radio"
          checked={categoryName === "Webinar"}
          value="Webinar"
          name="radio-category"
          onChange={handleRadioChange}
         />
         <span class="mailer-form-categories-checkmark"></span>
        </label>
       </div>
       <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
        <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
         <Stack direction={"column"}>
          <Typography>
           Is this communication part of any campaign?
           <span style={{ color: "red" }}>*</span>
          </Typography>
          <Typography>(If yes, select the campaign name)</Typography>
         </Stack>

         <FormControl>
          <RadioGroup
           row
           aria-labelledby="demo-row-radio-buttons-group-label"
           name="row-radio-buttons-group"
           value={launchCampaignVal}
           onChange={handleChange}
           sx={{ paddingLeft: "20px" }}
          >
           <FormControlLabel
            value="yes"
            control={
             <CustomRadio
              icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
              checkedIcon={
               <CheckCircleOutlineIcon style={{ fontSize: "1.3rem", color: "#9c27b0" }} />
              } // Checkmark inside circle when checked
             />
            }
            label="Yes"
           />
           <FormControlLabel
            value="no"
            control={
             <CustomRadio
              icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
              checkedIcon={
               <CheckCircleOutlineIcon style={{ fontSize: "1.3rem", color: "#9c27b0" }} />
              } // Checkmark inside circle when checked
             />
            }
            label="No"
           />
          </RadioGroup>
         </FormControl>
        </Stack>
        {launchCampaignVal == "yes" && (
         <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
          <Typography>Select the campaign</Typography>
          <Stack
           className="mail-form-headers"
           sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
            m: 1,
            width: 200,
            mt: 3,
           }}
           direction={"row"}
           spacing={2}
          >
           {/* <Select value={campaignItem} onChange={handleCampaignID} MenuProps={MenuProps}>
            {campaignList.message != "No campaign for this user." &&
             campaignList.length > 0 &&
             campaignList.map((item, index) => (
              <MenuItem key={index + 1} value={item.id}>
               {item.name}
              </MenuItem>
             ))}
           </Select> */}
           <Autocomplete
            value={options.find((option) => option.id === campaignItem) || null}
            onChange={(event, newValue) => {
             handleCampaignID(newValue);
            }}
            options={options}
            getOptionLabel={(option) => option.name || ""}
            ListboxProps={{
             style: {
              maxHeight: "150px", // Fixed height for the dropdown
              overflowY: "auto", // Enable vertical scrolling
             },
            }}
            renderInput={(params) => (
             <TextField
              sx={{ "& .MuiOutlinedInput-root": { padding: "2px !important" } }}
              {...params}
              variant="outlined"
             />
            )}
            filterSelectedOptions={false}
           />
          </Stack>
         </Stack>
        )}
       </Stack>
       <div className="mail-form-wrap">
        <div className="mail-form-inner-wrap">
         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontSize: "16px" }}>
           <span>
            Name<span style={{ color: "red" }}>*</span>
           </span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              {categoryName == "Program" ? (
               <p> Enter the program name </p>
              ) : categoryName == "Event" ? (
               <p> Enter the event name</p>
              ) : categoryName == "Microsite/Tool/Platform" ? (
               <p> Enter the Microsite/Tool/Platform name</p>
              ) : (
               <p> Enter the Webinar name</p>
              )}
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "6%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>

            <Autocomplete
            id="free-solo-demo"
            freeSolo
            value={programName}
            onChange={(event, newValue) => {
              setProgramName(newValue || ""); // Ensure value updates when selecting a suggestion
              setIsMailGenerated("enabled");
            }}
            onInputChange={(event, newInputValue) => {
              setProgramName(newInputValue); // Update state when typing
            }}
            disabled={!launchCampaignVal || (launchCampaignVal === "yes")}
            inputprops={{ readOnly: launchCampaignVal === "yes"}}
            options={programList.map((option) => option.programname)}
            renderInput={(params) => (
              <WhiteBorderTextField
                {...params}
                id="multiline"
                multiline
                minRows={1}
                maxRows={2}
                fullWidth
                placeholder={
                  categoryName === "Program"
                    ? "e.g: Java Full Stack"
                    : categoryName === "Event"
                    ? "e.g: ATCI Event"
                    : categoryName === "Microsite/Tool/Platform"
                    ? "e.g: ATCI Learning"
                    : "e.g: ATCI Webinar"
                }
                disabled={!launchCampaignVal || (launchCampaignVal === "yes" && campaignItem === 0)} 
              />
            )}
          />
         </Stack>
         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontSize: "16px" }}>
           <span>
            Launch Date<span style={{ color: "red" }}>*</span>
           </span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              {categoryName == "Program" ? (
               <p> Select program launch date. </p>
              ) : categoryName == "Event" ? (
               <p> Select event launch date.</p>
              ) : categoryName == "Microsite/Tool/Platform" ? (
               <p> Select Microsite/Tool/Platform launch date.</p>
              ) : (
               <p> Select webinar launch date.</p>
              )}{" "}
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "6%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
          <input
           type="date"
           className="maindate"
           min={today}
           disabled={
            launchCampaignVal == null || (launchCampaignVal == "yes" && campaignItem == 0)
             ? true
             : false
           }
           style={{ padding: "11px" }}
           readOnly={
            launchCampaignVal == "yes" && campaignItem != 0 && launchDate != ""
             ? true
             : false
           }
           onChange={(event) => {
            setLaunchDate(event.target.value);
            setIsMailGenerated("enabled");
           }}
           value={launchDate}
           onKeyDown={(e) => e.preventDefault()}
          />
         </Stack>
        </div>
        <div className="mail-form-inner-wrap">
         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontSize: "16px" }}>
           <span>
            Target Audience<span style={{ color: "red" }}>*</span>
           </span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              <p>Specify target audience</p>
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "6%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField
           // placeholder="Enter Target Audience"
           placeholder="e.g: CL10-CL8 across ATCI"
           id="multiline"
           multiline
           InputLabelProps={{ shrink: false }}
           minRows={1}
           disabled={
            launchCampaignVal == null || (launchCampaignVal == "yes" && campaignItem == 0)
             ? true
             : false
           }
           maxRows={2}
           onChange={(event) => {
            setTargAudience(event.target.value);
            setIsMailGenerated("enabled");
           }}
           fullWidth
           value={targAudience}
          />
         </Stack>
         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
           <span>
            Contact Info<span style={{ color: "red" }}>*</span>
           </span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              <p>Enter contact info for queries.</p>
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "6%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField
           // placeholder="Enter Contact Info"
           placeholder="e.g: support@jfs.com"
           id="multiline"
           multiline
           maxRows={1}
           disabled={
            launchCampaignVal == null || (launchCampaignVal == "yes" && campaignItem == 0)
             ? true
             : false
           }
           InputLabelProps={{ shrink: false }}
           onChange={(event) => {
            setContactInfo(event.target.value);
            setIsMailGenerated("enabled");
           }}
           fullWidth
           value={contactInfo}
          />
         </Stack>
        </div>
        <Stack
         className="mail-form-headers"
         sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginBottom: "10px",
         }}
        >
         <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
          <span>
           Introduction <span style={{ color: "lightgray" }}></span>
          </span>
          <HtmlTooltip
           arrow
           title={
            <React.Fragment>
             {categoryName == "Program" ? (
              <p> Enter a brief introduction about the program. </p>
             ) : categoryName == "Event" ? (
              <p> Enter a brief introduction about the event.</p>
             ) : categoryName == "Microsite/Tool/Platform" ? (
              <p> Enter a brief introduction about the Microsite/Tool/Platform.</p>
             ) : (
              <p> Enter a brief introduction about the webinar.</p>
             )}{" "}
            </React.Fragment>
           }
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
            style={{ width: "3%", cursor: "pointer" }}
           />
          </HtmlTooltip>
         </Typography>
         <WhiteBorderTextField
          placeholder="Introduction"
          id="multiline"
          multiline
          disabled={
           launchCampaignVal == null || (launchCampaignVal == "yes" && campaignItem == 0)
            ? true
            : false
          }
          minRows={3}
          InputLabelProps={{ shrink: false }}
          onChange={(event) => {
           setIntroduction(event.target.value);
           setIsMailGenerated("enabled");
          }}
          // sx={{ width: "20rem" }}
          fullWidth
          value={introduction}
         />
        </Stack>
        <Stack
         className="mail-form-headers"
         sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginBottom: "10px",
         }}
        >
         <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
          {/* Key Highlights <span style={{ color: "lightgray" }}></span> */}
          <span>
           Additional Info <span style={{ color: "lightgray" }}></span>
          </span>
          <HtmlTooltip
           arrow
           title={
            <React.Fragment>
             <p>Enter the Additional Info </p>
            </React.Fragment>
           }
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
            style={{ width: "3%", cursor: "pointer" }}
           />
          </HtmlTooltip>
         </Typography>
         <WhiteBorderTextField
          //placeholder="Key Highlights"
          placeholder="Enter Additional Information"
          id="multiline"
          disabled={
           launchCampaignVal == null || (launchCampaignVal == "yes" && campaignItem == 0)
            ? true
            : false
          }
          multiline
          minRows={3}
          InputLabelProps={{ shrink: false }}
          onChange={(event) => {
           //setKeyPoints(event.target.value);
           setAdditionalInfo(event.target.value);
           setIsMailGenerated("enabled");
          }}
          // sx={{ width: "20rem" }}
          fullWidth
          //    value={keyPoints}
          value={additionalInfo}
         />
        </Stack>
        <Stack
         className="mail-form-headers"
         sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginBottom: "10px",
         }}
        >
         <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
          <span>Call To Action </span>
          <span style={{ color: "lightgray" }}></span>
          <HtmlTooltip
           arrow
           title={
            <React.Fragment>
             <p>Encourage participants to take action.</p>
            </React.Fragment>
           }
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
            style={{ width: "3%", cursor: "pointer" }}
           />
          </HtmlTooltip>
         </Typography>
         <WhiteBorderTextField
          disabled={
           launchCampaignVal == null || (launchCampaignVal == "yes" && campaignItem == 0)
            ? true
            : false
          }
          id="multiline"
          multiline
          minRows={3}
          InputLabelProps={{ shrink: false }}
          onChange={(event) => {
           setCallToAction(event.target.value);
           setIsMailGenerated("enabled");
          }}
          fullWidth
          value={callToAction}
         />
        </Stack>

        <Stack
         className="mail-form-headers"
         sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginBottom: "10px",
         }}
        >
         <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
          <span>
           Additional Resources/Links <span style={{ color: "lightgray" }}></span>
          </span>
          <HtmlTooltip
           arrow
           title={
            <React.Fragment>
             <p>Enter additional resources or links </p>
            </React.Fragment>
           }
          >
           <img
            src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
            style={{ width: "3%", cursor: "pointer" }}
           />
          </HtmlTooltip>
         </Typography>
         <WhiteBorderTextField
          placeholder="Additional Resources/Links"
          id="multiline"
          multiline
          minRows={3}
          disabled={
           launchCampaignVal == null || (launchCampaignVal == "yes" && campaignItem == 0)
            ? true
            : false
          }
          InputLabelProps={{ shrink: false }}
          onChange={(event) => {
           setAdditionalResources(event.target.value);
           setIsMailGenerated("enabled");
          }}
          fullWidth
          value={additionalResources}
         />
        </Stack>
       </div>
      </div>

      <div className="btn-container">
       {navigatedToForm && (
        <button
         className="reset-btn"
         onClick={() => setIsMailGenerated("generateOutput")}
        >
         Next
        </button>
       )}
       {programName == "" ||
       launchDate == undefined ||
       targAudience == "" ||
       contactInfo == "" ||
       isMailGenerated == null ? (
        <div className="mailer-generate-btn-disable">
         <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
         <span>Generate</span>
        </div>
       ) : (
        <div className="mailer-generate-btn" onClick={handleGenerate}>
         <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
         <span>Generate</span>
        </div>
       )}
       {/* <button className="reset-btn" onClick={handleReset}>
        Reset
       </button> */}
      </div>
     </Stack>
    </Stack>
    {/* 
    <Regeneratepopup
     open={open}
     setOpen={setOpen}
     handleRegeneration={handleRegeneration}
    /> */}
   </Stack>
  </>
 );
};

export default MailForm;
